import StandIcon                      from "@/assets/icons/StandIcon";
import List                           from "@/components/list/List";
import EntityModel                    from "@/models/services/fondations/EntityModel";
import FileModel                      from "@/models/services/file/FileModel";
import EntitiesListRow                from "@/pages/Entity/components/Rows/EntitiesListRow";
import useApiCollection               from "@widesk-core/hooks/useApiCollection";
import usePagedCollection             from "@widesk-core/hooks/usePagedCollection";
import { useTranslation }             from "react-i18next";

export type EntitiesListBoxRowData = { entity: EntityModel };
export type EntitiesListBoxData = EntitiesListBoxRowData[];

const EntitiesListBox = () => {

	const { t } = useTranslation();

	const entityCollection = usePagedCollection(EntityModel);
	const fileCollection   = useApiCollection(FileModel);

	return (
		<List
			collection={entityCollection}
			afterFetch={async () => {
				const entityUrns = entityCollection.map(m => m.urn);
				await fileCollection
					.setFilter('typeSource.type.reference', 'contact_photo')
					.setSort('createdAt', 'desc')
					.listBy(entityUrns, 'typeSource.source.entityUrn');
				await fileCollection.whenIsLoaded(m => m.typeSource.source);
			}}
			renderRow={(model) => {
				return <EntitiesListRow entity={model} fileCollection={fileCollection} />;
			}}
			options={{
				clickable: true,
				emptyMessages: {
					title: t('pages.entities.list.empty.title'),
					description: t('pages.entities.list.empty.description'),
					icon: <StandIcon size="xl" />,
				},
				itemsMargin: '10px 0px 10px 0px',
				itemsPadding: '10px',
				padding: '0px 10px 0px 10px',
				withSeparators: true,
			}}
		/>
	)
}

export default EntitiesListBox;
